(function () {
  setTimeout(() => {
    if (!window._providers) {
      window._providers = {}
    }
    const axiosInstance = createAxiosInstance({
      baseURL: apiBaseUrl || ddlRequestBaseUrl
    }, {
      response: {
        onFulfilled: function (response) {
          return response
        },
        onRejected: function (error) {
          return error.response
        }
      }
    })
  
    window._providers['ddl'] = {
      applySubmit: function (payload) {
        return axiosInstance.post('rcs/composite/email/push', payload)
          .then(res => res.data)
          .catch(e => e)
      }
    }
  })
})()